import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconShakacodeDoc = ({
  title = "Shakacode logo",
  viewBoxWidth = 212,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#F32B05" offset="0%" />
        <stop stopColor="#B00012" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="24.6%" x2="50%" y2="72.6%" id="c">
        <stop stopColor="#FF6956" offset=".8%" />
        <stop stopColor="#FF6956" stopOpacity="0" offset="96.6%" />
      </linearGradient>
      <path
        d="M8.7 7.5h30.6a2 2 0 011.8 1l6.2 11.9a2 2 0 01-.5 2.4L25.3 41.6a2 2 0 01-2.6 0L1.2 22.8a2 2 0 01-.5-2.4L7 8.6c.4-.7 1-1.1 1.8-1.1z"
        id="a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect fill="#FFF" width="212" height="64" rx="4" />
      <text
        fontFamily="Montserrat-Bold, Montserrat"
        fontSize="14"
        fontWeight="bold"
        fill="#1F2323"
      >
        <tspan x="88" y="42">
          ShakaCode
        </tspan>
      </text>
      <text
        fontFamily="Montserrat-Medium, Montserrat"
        fontSize="13"
        fontWeight="400"
        fill="#88969A"
      >
        <tspan x="88" y="29">
          Developed by
        </tspan>
      </text>
      <g transform="translate(24 8)">
        <path d="M0 0h48v48H0z" />
        <mask id="d" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="url(#b)" xlinkHref="#a" />
        <path
          d="M5.3 32.3c16.5-1.7 25.1-5 25.7-10 .9-7.6-13-1.1-15.7-.8a58.3 58.3 0 0127.8-10.2h6.4v31.4H5.2V32.3z"
          fill="url(#c)"
          mask="url(#d)"
        />
      </g>
    </g>
  </Svg.Icon>
)

export default IconShakacodeDoc
